
// TODO: Implementar el comportamiento de autogrow en textarea

function AutoGrowTextAreaComponent() {
  return (
    <textarea
      className="input p-0 rounded ChooseItemTitle-resize-none"
      placeholder="Escribí tu pregunta..."
      defaultValue={""}
    />
  )
}

export default AutoGrowTextAreaComponent
